<template>
  <Fancybox
    :options="{
      Dots: false,
      Thumbs: false,
    }"
    :imgs="data"
    class="fancy-slides pb-20"
  >
    <CarouselKeen :slides="5">
      <div
        v-for="(id, index) in data"
        :key="index"
        class="keen-slider__slide before:pointer-events-none before:absolute before:inset-0 before:z-10 before:bg-black before:opacity-40 before:transition-all before:duration-300 hover:before:opacity-0"
      >
        <a
          data-fancybox="gallery"
          data-type="iframe"
          :data-src="`https://www.tiktok.com/player/v1/${id}?music_info=0&description=0&rel=0&fullscreen_button=1&autoplay=1`"
          href="javascript:;"
        >
          <iframe
            class="pointer-events-none h-[495px]"
            :src="`https://www.tiktok.com/player/v1/${id}?music_info=0&description=0&rel=0&fullscreen_button=0&controls=0&progress_bar=0&timestamp=0&closed_caption=0`"
            allow="fullscreen"
            width="100%"
          ></iframe>
        </a>
      </div>
    </CarouselKeen>
  </Fancybox>
</template>

<script>
import Fancybox from "../Fancybox/index.vue";
import CarouselKeen from "../Carousel/CarouselKeen.vue";

export default {
  name: "fancy-videos",
  components: {
    Fancybox,
    CarouselKeen,
  },
  props: {
    ids: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      data: this.ids
        .split(",")
        .map(id => id.trim())
        .filter(id => id !== ""),
    };
  },
  methods: {},
};
</script>
<style>
.fancy-slides .keen-slider {
  @apply !overflow-visible sm:justify-center;
}
.fancy-slides .button-nav {
  @apply sm:!hidden;
}
.fancybox__content {
  @apply border-[3px] border-pastelPinkL !p-0;
}
</style>
